<template>
  <v-row no-gutters>
    <v-col>
      <v-card class="pa-2 my-2 mr-2">
        <v-row no-gutters>
          <v-col class="d-flex align-center">
            <span class="subtitle-1">Проектів:</span>
            <v-spacer />
            <span class="title">{{ projectsCount }}</span>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col>
      <v-card class="pa-2 my-2">
        <v-row no-gutters>
          <v-col class="d-flex align-center">
            <span class="subtitle-1">Разом:</span>
            <v-spacer />
            <span class="title">
              {{ spentHoursTotal | decimal }}
              <span class="font-weight-medium body-1">год</span>
            </span>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ["projectsCount", "spentHoursTotal"],
};
</script>
